import React, { useState } from "react";
import {
  Box,
  Card,
  CardContent,
  Chip,
  Typography,
  Button,
  IconButton,
  useTheme,
  useMediaQuery,
} from "@mui/material";
import AddCircleOutlineIcon from "@mui/icons-material/AddCircleOutline";
import RemoveCircleOutlineIcon from "@mui/icons-material/RemoveCircleOutline";

const MultiSelectChipsWithSubcategories = ({ onConsumptionChange }) => {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("sm"));
  // Define consumption patterns in kWh
  const homeTypes = [
    {
      label: "Big Family House",
      consumption: {
        winter: [2.5, 2.4, 2.2, 2.0, 2.1, 2.5, 3.0, 3.5, 3.8, 3.6, 3.2, 2.8],
        summer: [1.8, 1.7, 1.6, 1.5, 1.8, 2.2, 2.5, 2.7, 3.0, 2.8, 2.5, 2.0],
        spring: [2.0, 2.0, 1.8, 1.7, 1.8, 2.0, 2.3, 2.5, 2.7, 2.6, 2.4, 2.2],
        autumn: [2.2, 2.1, 2.0, 1.9, 2.0, 2.2, 2.6, 2.8, 3.0, 2.9, 2.7, 2.5],
      },
    },
    {
      label: "Single Flat",
      consumption: {
        winter: [1.2, 1.1, 1.0, 0.9, 1.0, 1.2, 1.4, 1.6, 1.8, 1.7, 1.5, 1.3],
        summer: [0.8, 0.7, 0.7, 0.6, 0.8, 1.0, 1.2, 1.3, 1.5, 1.4, 1.3, 1.0],
        spring: [1.0, 1.0, 0.9, 0.8, 0.9, 1.1, 1.3, 1.4, 1.6, 1.5, 1.4, 1.2],
        autumn: [1.1, 1.0, 1.0, 0.9, 1.0, 1.2, 1.5, 1.6, 1.8, 1.7, 1.5, 1.3],
      },
    },
    {
      label: "Small Family House",
      consumption: {
        winter: [1.8, 1.7, 1.5, 1.4, 1.5, 1.8, 2.0, 2.3, 2.5, 2.4, 2.2, 1.9],
        summer: [1.2, 1.1, 1.0, 0.9, 1.1, 1.3, 1.5, 1.7, 1.8, 1.6, 1.4, 1.2],
        spring: [1.5, 1.4, 1.3, 1.2, 1.3, 1.5, 1.8, 2.0, 2.2, 2.1, 1.9, 1.7],
        autumn: [1.6, 1.5, 1.4, 1.3, 1.4, 1.6, 1.9, 2.1, 2.3, 2.2, 2.0, 1.8],
      },
    },
    {
      label: "Studio Apartment",
      consumption: {
        winter: [0.9, 0.8, 0.7, 0.6, 0.7, 0.9, 1.1, 1.3, 1.4, 1.3, 1.1, 0.9],
        summer: [0.6, 0.5, 0.5, 0.4, 0.6, 0.7, 0.9, 1.0, 1.1, 1.0, 0.9, 0.7],
        spring: [0.7, 0.7, 0.6, 0.5, 0.6, 0.8, 1.0, 1.1, 1.3, 1.2, 1.1, 0.9],
        autumn: [0.8, 0.7, 0.7, 0.6, 0.7, 0.9, 1.2, 1.3, 1.4, 1.3, 1.1, 0.9],
      },
    },
  ];

  const appliances = [
    {
      label: "Electric Car",
      consumption: [0, 0, 0, 0, 0, 6.0, 0, 0, 0, 0, 0, 0],
    },
    {
      label: "Home Office",
      consumption: [0.2, 0.2, 0.2, 0.2, 0.2, 0.3, 0.3, 0.3, 0.2, 0.2, 0.2, 0.2],
    },
    {
      label: "Air Conditioning",
      consumption: [0, 0, 0, 0, 0, 1.5, 1.5, 1.5, 1.5, 1.5, 1.0, 0],
    },
  ];

  const [selectedHomeType, setSelectedHomeType] = useState(null);
  const [selectedAppliances, setSelectedAppliances] = useState([]);
  const [averageMonthlyConsumption, setAverageMonthlyConsumption] = useState(0);

  const calculateConsumption = (homeType, applianceLabels) => {
    const newSeasonalConsumption = ["winter", "spring", "summer", "autumn"].map(
      (season) => Array(12).fill(0)
    );

    // Add home type consumption
    if (homeType) {
      ["winter", "spring", "summer", "autumn"].forEach((season, seasonIdx) => {
        homeType.consumption[season].forEach((value, idx) => {
          newSeasonalConsumption[seasonIdx][idx] += value;
        });
      });
    }

    // Add appliance consumption
    applianceLabels.forEach((applianceLabel) => {
      const appliance = appliances.find((a) => a.label === applianceLabel);
      if (appliance && appliance.consumption) {
        newSeasonalConsumption.forEach((seasonConsumption) => {
          appliance.consumption.forEach((value, idx) => {
            seasonConsumption[idx] += value;
          });
        });
      }
    });

    const monthlyAverages = newSeasonalConsumption[0]
      .flat()
      .reduce((acc, val) => acc + val, 0);
    onConsumptionChange(newSeasonalConsumption);
    console.log("newSeasonalConsumption");
    console.log(newSeasonalConsumption);
    setAverageMonthlyConsumption(monthlyAverages);
  };

  const handleHomeTypeClick = (category) => {
    const isSelected = selectedHomeType === category.label;
    const newSelectedHomeType = isSelected ? null : category.label;
    setSelectedHomeType(newSelectedHomeType);

    const homeType = homeTypes.find((ht) => ht.label === newSelectedHomeType);
    calculateConsumption(homeType, selectedAppliances);
  };

  const handleApplianceClick = (category) => {
    const isSelected = selectedAppliances.includes(category.label);
    const updatedSelectedAppliances = isSelected
      ? selectedAppliances.filter((label) => label !== category.label)
      : [...selectedAppliances, category.label];

    setSelectedAppliances(updatedSelectedAppliances);

    const homeType = homeTypes.find((ht) => ht.label === selectedHomeType);
    calculateConsumption(homeType, updatedSelectedAppliances);
  };

  const adjustConsumption = (delta) => {
    setAverageMonthlyConsumption((prev) => Math.max(prev + delta, 0));
  };

  return (
    <Card
      sx={{
        backgroundColor: "#28293e",
        px: { xs: 2, sm: 4 },
        py: { xs: 2, sm: 5 },
        width: "80%",
        mb: 3,
        mx: "auto",
      }}
    >
      <CardContent>
        <Typography
          variant={isMobile ? "h6" : "h5"}
          gutterBottom
          sx={{ textAlign: "center", color: "#fff" }}
        >
          Hourly Consumption Calculator
        </Typography>

        <Typography
          variant={isMobile ? "subtitle1" : "h6"}
          sx={{ color: "#fff", mt: 2 }}
        >
          Select Residence Type
        </Typography>
        <Box sx={{ display: "flex", flexWrap: "wrap", gap: 1, mt: 1 }}>
          {homeTypes.map((category) => (
            <Chip
              key={category.label}
              label={category.label}
              onClick={() => handleHomeTypeClick(category)}
              sx={{
                backgroundColor:
                  selectedHomeType === category.label ? "#ff6f61" : "#1c1c28",
                color: "#fff",
                cursor: "pointer",
              }}
            />
          ))}
        </Box>

        <Typography
          variant={isMobile ? "subtitle1" : "h6"}
          sx={{ color: "#fff", mt: 3 }}
        >
          Select Appliances
        </Typography>
        <Box sx={{ display: "flex", flexWrap: "wrap", gap: 1, mt: 1 }}>
          {appliances.map((category) => (
            <Chip
              key={category.label}
              label={category.label}
              onClick={() => handleApplianceClick(category)}
              sx={{
                backgroundColor: selectedAppliances.includes(category.label)
                  ? "#ff6f61"
                  : "#1c1c28",
                color: "#fff",
                cursor: "pointer",
              }}
            />
          ))}
        </Box>

        <Typography
          variant={isMobile ? "body1" : "h6"}
          sx={{ color: "#fff", mt: 3, textAlign: "center" }}
        >
          Average Daily Consumption: {averageMonthlyConsumption.toFixed(2)} kWh
        </Typography>
        <Box sx={{ mt: 2, display: "flex", justifyContent: "center", gap: 2 }}>
          <IconButton
            onClick={() => adjustConsumption(-10)}
            disabled={averageMonthlyConsumption <= 0}
            sx={{ color: "#ff6f61" }}
          >
            <RemoveCircleOutlineIcon fontSize="large" />
          </IconButton>
          <IconButton
            onClick={() => adjustConsumption(10)}
            sx={{ color: "#ff6f61" }}
          >
            <AddCircleOutlineIcon fontSize="large" />
          </IconButton>
        </Box>
      </CardContent>
    </Card>
  );
};
export default MultiSelectChipsWithSubcategories;
